"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plus = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importDefault(require("react"));
var Plus = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 16 16", fill: "none" },
        react_1.default.createElement("path", { d: "M8 3v10M3 8h10", stroke: color, strokeWidth: "2", strokeLinecap: "round" })));
};
exports.Plus = Plus;
